import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import './Filters.css';
import {
    IconX,
    IconRefresh,
    IconCalendarWeek,
    IconAdjustmentsHorizontal,
    IconBriefcase2,
    IconTargetArrow,
    IconBolt,
    IconCalendarTime,
    IconArrowRight,
    IconBox,
} from "@tabler/icons-react";
import DatePicker from "react-datepicker";
import { TreeSelect } from "primereact/treeselect";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import ProductSelectModal from "./ProductSelectModal";
import moment from "moment";

const SUBSTATUS_OPTIONS = {
    PENDING: [
        { value: "PENDING", label: "Pending" },
        { value: "PO-Pending", label: "PO Pending" },
        { value: "Pre-Payment-Pending", label: "Pre-Payment Pending" },
    ],
    "IN PROGRESS": [
        { value: "IN PROGRESS", label: "In Progress" },
        { value: "In-Transit-to-Warehouse", label: "In Transit to Warehouse" },
        { value: "At-Warehouse", label: "At Warehouse" },
        { value: "Warehouse-Ready-to-Ship", label: "Warehouse Ready to Ship" },
        { value: "In-Transit-to-Customer", label: "Back Ordered / Partial Orders" },
    ],
    DELIVERED: [
        { value: "DELIVERED", label: "Shipped" },
        { value: "ARO", label: "AR Closed" },
        { value: "Post-Payment-Pending", label: "Post-Payment Pending" },
        { value: "Invoice-Payment-Pending", label: "Invoice Payment Pending" },
    ],
    PAID_CLOSED: [
        { value: "PAID_CLOSED", label: "Paid & Closed" },
        { value: "Vendor-Bill-Pending", label: "Vendor Bill Pending" },
        { value: "Vendor-Payment-Pending", label: "Vendor Payment Pending" },
    ],
    LOST_CANCELLED: [],
};

const STAGE_LABEL = {
    PENDING: "Pending",
    "IN PROGRESS": "In Progress",
    DELIVERED: "Shipped",
    PAID_CLOSED: "Paid & Closed",
    LOST_CANCELLED: "Lost/Cancelled",
};

const initState = {
    salesLead: "",
    contractVehicle: "",
    orderType: "",
    paymentType: "",
    stage: "",
    subStatuses: [],
    vendor: "",
    vendor_name: "",
    selectedProducts: [],
    createdFrom: null,
    createdTo: null,
    fulfillmentFrom: null,
    fulfillmentTo: null,
    warehouseFrom: null,
    warehouseTo: null,
};


const SectionHeader = ({ icon: Icon, type = "general", label }) => {
    const typeStyles = {
        general: { bg: "bg-orange-lt", text: "text-indigo" },
        specific: { bg: "bg-indigo-lt", text: "text-indigo" },
        dates: { bg: "bg-green-lt", text: "text-indigo" },
    };
    const styles = typeStyles[type] || typeStyles.general;

    return (
        <div className="filters-section-wrap">
            <div className="filters-section-label">
                <div className={`bagde_filters  ${styles.bg} d-flex align-items-center justify-content-center section-icon`}>
                    <Icon size={12} className={styles.text} />
                </div>
                <span className={styles.text}>{label}</span>
                <div className="filters-section-divider" />
            </div>

        </div>
    );
};

function Filters({
    show,
    onHide,
    initialValues = {},
    salesHeadData = [],
    contractData = [],
    onApply,
    matchCount = 0,
    totalCount = 0,
    anchorRef,
}) {
    const [f, setF] = useState(() => {
        const savedFilters = localStorage.getItem("orderFilters");

        if (savedFilters) {
            const parsed = JSON.parse(savedFilters);

            return {
                ...initState,
                ...parsed,
                createdFrom: parsed.createdFrom ? moment(parsed.createdFrom).format("YYYY-MM-DD") : undefined,
                createdTo: parsed.createdTo ? moment(parsed.createdTo).format("YYYY-MM-DD") : undefined,
                fulfillmentFrom: parsed.fulfillmentFrom ? moment(parsed.fulfillmentFrom).format("YYYY-MM-DD") : undefined,
                fulfillmentTo: parsed.fulfillmentTo ? moment(parsed.fulfillmentTo).format("YYYY-MM-DD") : undefined,
                warehouseFrom: parsed.warehouseFrom ? moment(parsed.warehouseFrom).format("YYYY-MM-DD") : undefined,
                warehouseTo: parsed.warehouseTo ? moment(parsed.warehouseTo).format("YYYY-MM-DD") : undefined,
            };
        }

        return initState;
    });
    const [showProductModal, setShowProductModal] = useState(false);
    const panelRef = useRef(null);

    const { data: vendorlist, postData: fetchVendorList } = usePostRequest(
        API_ENDPOINTS.GET_VENDORS
    );

    useEffect(() => {
        fetchVendorList({ page: 1, limit: 500, is_relevent: true });
    }, []);

    useEffect(() => {
        if (show) setF((p) => ({ ...initState, ...initialValues }));
    }, [show]);


    useEffect(() => {
        if (!show) return;
        const handleClickOutside = (e) => {
            if (
                panelRef.current &&
                !panelRef.current.contains(e.target) &&
                anchorRef?.current &&
                !anchorRef.current.contains(e.target)
            ) { 
                if (
                    e.target.closest(".p-treeselect-panel") ||
                    e.target.closest(".react-datepicker") ||
                    e.target.closest(".modal")
                ) return;
                onHide();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [show, onHide, anchorRef]);

    useEffect(() => {
        localStorage.setItem("orderFilters", JSON.stringify(f));
    }, [f]);

    const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

    const toggleSubStatus = (val) => {
        setF((p) => {
            const exists = p.subStatuses.includes(val);
            return {
                ...p,
                subStatuses: exists
                    ? p.subStatuses.filter((s) => s !== val)
                    : [...p.subStatuses, val],
            };
        });
    };

    const handleStageChange = (val) => {
        setF((p) => ({ ...p, stage: val, subStatuses: [] }));
    };

    const handleReset = () => {
        setF(initState);
        localStorage.removeItem("orderFilters");
    };
    // const handleApply = () => {
    //     localStorage.setItem("orderFilters", JSON.stringify(f));
    //     onApply?.(f);
    //     onHide();
    // };

const handleApply = () => {
    const pairs = [
        ["createdFrom", "createdTo", "Created Date"],
        ["fulfillmentFrom", "fulfillmentTo", "Est. Fulfillment Date"],
        ["warehouseFrom", "warehouseTo", "Est. Warehouse Date"],
    ];

    for (const [a, b, label] of pairs) {
        if ((f[a] && !f[b]) || (!f[a] && f[b])) {
            toast.error(`Please select both "from" and "to" for ${label}`);
            return;
        }
    }

    localStorage.setItem("orderFilters", JSON.stringify(f));
    onApply?.(f);
    onHide();
};
    const treeOptions = [
        { key: "", label: "All", selectable: true, children: [] },
        ...(contractData || []).map((vehicle) => ({
            key: String(vehicle.id),
            label: vehicle.name,
            selectable: true,
            children:
                vehicle.children?.map((child) => ({
                    key: String(child.id),
                    label: child.name,
                    selectable: true,
                    children: [],
                })) || [],
        })),
    ];

    const subStatusList = SUBSTATUS_OPTIONS[f.stage] || [];
    const stageLabel = STAGE_LABEL[f.stage] || "";

    // const dateInput = (val, onChange, minDate) => (
    //     <InputGroup>
    //         <InputGroup.Text>
    //             <IconCalendarWeek />
    //         </InputGroup.Text>
    //         <DatePicker
    //             className="form-control"
    //             selected={val}
    //             placeholderText="Select Date"
    //             onChange={onChange}
    //             minDate={minDate}
    //             showMonthDropdown
    //             showYearDropdown
    //         />
    //     </InputGroup>
    // );

    const dateInput = (val, onChange, minDate, maxDate) => (
        <InputGroup>
            <InputGroup.Text>
                <IconCalendarWeek />
            </InputGroup.Text>
            <DatePicker
                className="form-control"
                selected={val}
                placeholderText="Select Date"
                onChange={onChange}
                minDate={minDate}
                maxDate={maxDate}
                showMonthDropdown
                showYearDropdown
            />
        </InputGroup>
    );

    // const dateRangeRow = (label, fromVal, toVal, fromKey, toKey) => (
    //     <Row className="g-2 mb-3 align-items-end">
    //         <Col xs={5}>
    //             <div className="filters-date-field-label">{label} from</div>
    //             {dateInput(fromVal, (d) => set(fromKey, d))}
    //         </Col>
    //         <Col xs={1} className="filters-arrow-col">
    //             <IconArrowRight size={16} className="text-secondary" />
    //         </Col>
    //         <Col xs={6}>
    //             <div className="filters-date-field-label">{label} to</div>
    //             {dateInput(toVal, (d) => set(toKey, d), fromVal)}
    //         </Col>
    //     </Row>
    // );

    const dateRangeRow = (label, fromVal, toVal, fromKey, toKey, maxDate) => (
        <Row className="g-2 mb-3 align-items-end">
            <Col xs={5}>
                <div className="filters-date-field-label">{label} from</div>
                {dateInput(fromVal, (d) => set(fromKey, d), undefined, maxDate)}
            </Col>
            <Col xs={1} className="filters-arrow-col">
                <IconArrowRight size={16} className="text-secondary" />
            </Col>
            <Col xs={6}>
                <div className="filters-date-field-label">{label} to</div>
                {dateInput(toVal, (d) => set(toKey, d), fromVal, maxDate)}
            </Col>
        </Row>
    );

    const handleVendorChange = (e) => {
        const selectedId = e.target.value;

        const selectedVendor = (vendorlist?.data || []).find(
            (v) => String(v.id) === String(selectedId)
        );

        setF((prev) => ({
            ...prev,
            vendor: selectedId,
            vendor_name: selectedVendor ? selectedVendor.display_name : ""
        }));
    };

    if (!show) return null;

    return (
        <>
            <ProductSelectModal
                show={showProductModal}
                onHide={() => setShowProductModal(false)}
                selectedProducts={f.selectedProducts || []}
                onApply={(products) => set("selectedProducts", products)}
            />

            <div ref={panelRef} className="filters-dropdown-panel">
                <div className="filters-header">
                    <h5 className="filters-title">Refine Orders</h5>
                    <div className="d-flex align-items-center gap-3">
                        <Button
                            variant="link"
                            className="filters-reset-btn text-secondary"
                            onClick={handleReset}
                        >
                            <IconRefresh size={14} /> Reset all
                        </Button>
                        <span role="button" onClick={onHide} className="text-secondary" style={{ cursor: "pointer" }}>
                            <IconX size={20} />
                        </span>
                    </div>
                </div>

                <div className="filters-body">
                    <SectionHeader icon={IconBriefcase2} type="general" label="GENERAL" />

                    <Row className="g-3 mb-2">
                        <Col xs={4}>
                            <div className="filters-field-label">Sales Lead</div>
                            <Form.Select
                                className="filters-input"
                                value={f.salesLead}
                                onChange={(e) => set("salesLead", e.target.value)}
                            >
                                <option value="">Select</option>
                                {salesHeadData.map((s, index) => (
                                    <option key={s.id || index} value={s.email}>{s.email}</option>
                                ))}
                            </Form.Select>
                        </Col>

                        <Col xs={4}>
                            <div className="filters-field-label">Contract Vehicle</div>
                            <TreeSelect
                                value={f.contractVehicle ? String(f.contractVehicle) : null}
                                onChange={(e) => set("contractVehicle", e.value ?? "")}
                                options={treeOptions}
                                placeholder="Select"
                                filter
                                filterPlaceholder="Search contract vehicle"
                                className="w-100 filter-treeselect"
                                appendTo={document.body}
                                panelClassName="filter-treeselect-panel"
                            />
                        </Col>

                        <Col xs={4}>
                            <div className="filters-field-label">Order Type</div>
                            <Form.Select
                                className="filters-input"
                                value={f.orderType}
                                onChange={(e) => set("orderType", e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="DS">Dropship</option>
                                <option value="CRK">Consolidate / Repack</option>
                                <option value="M">Manufacturing</option>
                                <option value="KIT">Kit</option>
                                <option value="S">Stock</option>
                            </Form.Select>
                        </Col>

                        <Col xs={6}>
                            <div className="filters-field-label">Order Payment Type</div>
                            <Form.Select
                                className="filters-input"
                                value={f.paymentType}
                                onChange={(e) => set("paymentType", e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="invoiced">Invoiced</option>
                                <option value="pre-paid">Prepaid</option>
                                <option value="post-paid">Postpaid</option>
                            </Form.Select>
                        </Col>

                        <Col xs={6}>
                            <div className="filters-field-label">Stage</div>
                            <Form.Select
                                className="filters-input"
                                value={f.stage}
                                onChange={(e) => handleStageChange(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="PENDING">Pending</option>
                                <option value="IN PROGRESS">In Progress</option>
                                <option value="DELIVERED">Shipped</option>
                                <option value="PAID_CLOSED">Paid & Closed</option>
                                <option value="LOST_CANCELLED">Lost/Cancelled</option>
                            </Form.Select>
                        </Col>
                    </Row>

                    {subStatusList.length > 0 && (
                        <div className="mb-2 mt-2">
                            <div className="filters-substatus-label">{stageLabel} Statuses</div>
                            <div className="d-flex flex-wrap gap-1 filter-substatus">
                                {subStatusList.map((opt) => (
                                    <Form.Check
                                        key={opt.value}
                                        type="checkbox"
                                        id={`sub-${opt.value}`}
                                        label={opt.label}
                                        checked={f.subStatuses.includes(opt.value)}
                                        onChange={() => toggleSubStatus(opt.value)}
                                    />
                                ))}
                            </div>
                        </div>
                    )}

                    <SectionHeader icon={IconBolt} type="specific" label="SPECIFIC" />

                    <Row className="g-3 mb-2 align-items-end">
                        <Col xs={6}>
                            <div className="filters-field-label">Vendor</div>
                            <Form.Select
                                className="filters-input"
                                value={f.vendor}
                                onChange={handleVendorChange}
                            >
                                <option value="">Select</option>
                                {(vendorlist?.data || []).map((v) => (
                                    <option key={v.id} value={v.id}>{v.display_name}</option>
                                ))}
                            </Form.Select>
                        </Col>

                        <Col xs={6}>
                            <div onClick={() => setShowProductModal(true)} className="filters-product-select">
                                <div className="filters-product-icon avatar bg-indigo-lt ">
                                    <IconBox size={14} />
                                </div>
                                <div className="filters-product-text">
                                    <div className="fw-semibold form-label text-dark mb-0">
                                        {f.selectedProducts?.length || 0} products selected
                                    </div>
                                    <div className="text-specific">Click to edit selection</div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <SectionHeader icon={IconCalendarTime} type="dates" label="DATES" />

                    {dateRangeRow("Created Date", f.createdFrom, f.createdTo, "createdFrom", "createdTo", new Date())}
                    {dateRangeRow("Est. Fulfillment Date", f.fulfillmentFrom, f.fulfillmentTo, "fulfillmentFrom", "fulfillmentTo")}
                    {dateRangeRow("Est. Warehouse Date", f.warehouseFrom, f.warehouseTo, "warehouseFrom", "warehouseTo")}

                    {/* {dateRangeRow("Created Date", f.createdFrom, f.createdTo, "createdFrom", "createdTo")}
                    {dateRangeRow("Est. Fulfillment Date", f.fulfillmentFrom, f.fulfillmentTo, "fulfillmentFrom", "fulfillmentTo")}
                    {dateRangeRow("Est. Warehouse Date", f.warehouseFrom, f.warehouseTo, "warehouseFrom", "warehouseTo")} */}
                </div>

                <div className="filters-footer">
                    <div className="small text-muted">
                        Live preview:{" "}
                        <span className="fw-bold text-orange">{matchCount}</span>{" "}
                        of <span className="fw-bold text-dark">{totalCount}</span> orders
                    </div>
                    <div className="d-flex gap-2">
                        <Button variant="light" onClick={onHide} className="border">Cancel</Button>
                        <Button onClick={handleApply} className="text-white border-0 btn btn-warning">
                            Apply Filters
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Filters;